export default __webpack_public_path__ + "static/media/Radiology Order.59acad91.svg";